export default __webpack_public_path__ + "dist/media/Section 5.c1b58f82.png";